import { ChangeDetectionStrategy, Component, signal, WritableSignal } from '@angular/core';
import { PresenterType } from '@app/shared';
import { SelectOptionMessage } from './select-option.message';


@PresenterType(
{
    model: SelectOptionMessage
})
@Component({
  selector: 'select-option-message',
  standalone: false,
  templateUrl: './select-option-message.component.html',
  styleUrl: './select-option-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectOptionMessageComponent {
  public data: WritableSignal<SelectOptionMessage>;
  
  constructor() {
      this.data = signal<SelectOptionMessage>(null);
  }
}
